import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/contexts/AuthContext'
import { Toaster } from '@/components/ui/Toaster'
import { TooltipProvider } from '@/components/ui/Tooltip'
import { queryClient } from './queryClient'

interface ProvidersProps {
  children: React.ReactNode
}

/**
 * Wraps the app with QueryClient, Auth, and Toaster.
 * Keeps wiring separate from product code.
 */
export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          {children}
        </TooltipProvider>
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  )
}
